<template>
    <div id="standAndFun">
       <div class="columns" :class="{ reverse: isReversed }">
           <div class="column is-8">
               <h5 v-if="standAndFun.title" class="challenge-title is-size-3 has-text-left">{{ $t(standAndFun.title) }}</h5>
               <p v-html="$t(standAndFun.content)"></p>   
            </div>
            <div class="column is-3">
                <figure class="image is-square">
                    <img :src="standAndFun.imagePath" alt="sdasd">
                </figure>            
           </div>
       </div>
    </div>
</template>

<script>
import standAndFun from"@/assets/resources/standAndFun(about).js"
export default {
    props: [
        'isReversed',
    ],
    data(){
        return{
            standAndFun
        }
    }
}
</script>

<style lang="scss" scoped>
#rowSection {
    border-bottom: 1px solid $secondary-color;
}

.columns {
    margin-bottom: 2rem;
    margin-top: 2rem;
    justify-content: space-between;
}

.reverse {
    flex-direction: row-reverse;
}

img {
    object-fit: cover;
}

.challenge-title {
    margin-bottom: 20px;
}

@media only screen and (max-width: 600px) {
  .columns {
      display: flex;
      flex-direction: column-reverse;
  }
 
}
</style>
